import { render } from "./CardCalendar.vue?vue&type=template&id=74e3dc67"
import script from "./CardCalendar.vue?vue&type=script&lang=js"
export * from "./CardCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2980638495/src/developer.gov.sg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__